const initialState = {
  skipped: false,
};

export function skip() {
  return { type: 'joyride/skip' };
}

export default function (state = initialState, action) {
  if (action.type === 'joyride/skip') {
    return { skipped: true };
  }

  return state;
}



// WEBPACK FOOTER //
// ./app/ducks/joyride.js